import {
  ITEM_STATE_LOADING_FAILED,
  ITEM_STATE_PLACEHOLDER
} from "../../constants";

export default state => ({
  ...state,
  items: [
    ...state.items.map(item => ({
      ...item,
      itemState:
        item.itemState === ITEM_STATE_LOADING_FAILED
          ? ITEM_STATE_PLACEHOLDER
          : item.itemState
    }))
  ]
});
